<script>
import ImpressionModels from "@/views/Impression/Components/ImpressionModels.vue";
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";
import PaySlipFilter from "@/views/PaySlip/Components/PaySlipFilter.vue";

export default {
    components: {PaySlipFilter, ImpressionModels},
    setup() {
        const {$moment, $i18n} = useTools();
        const {loading, filter} = useSharedData();
        const {rowColor, itemClick, priceFormat} = useSharedMethod();
        const {transformFilterValues} = useSharedMethod();
        
        filter.value = {
            closed: null,
        };
        
        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
        }
        
        const irgs = ref([]);
        const year = ref($moment().year() - 1);
        const cnasAgencyId = ref(null);
        
        const headers = [
            {
                text: $i18n.t('worker.code'),
                align: "start",
                sortable: true,
                value: "matricule"
            },
            {
                text: `${$i18n.t('common.last_name')} & ${$i18n.t('common.first_name')}`,
                align: "start",
                sortable: true,
                value: "name"
            },
            {
                text: $i18n.t('data_select.WORKER_FAMILY_SITUATION'),
                align: "start",
                sortable: true,
                value: "situationFamiliale"
            },
            {
                text: $i18n.t('impression.children_number'),
                align: "start",
                sortable: true,
                value: "nombreEnfant"
            },
            {
                text: $i18n.t('module.occupation'),
                align: "start",
                sortable: true,
                value: "fonction"
            },
            {
                text: `${$i18n.t('common.total')} ${$i18n.t('impression.impos')}`,
                align: "end",
                sortable: true,
                value: "totalBaseImposable"
            },
            {
                text: `${$i18n.t('common.total')} ${$i18n.t('impression.irg')}`,
                align: "end",
                sortable: true,
                value: "totalIrg"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.JANUARY')}`,
                align: "end",
                sortable: true,
                value: "baseImposableJanuary"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.JANUARY')}`,
                align: "end",
                sortable: true,
                value: "irgJanuary"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.FEBRUARY')}`,
                align: "end",
                sortable: true,
                value: "baseImposableFebruary"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.FEBRUARY')}`,
                align: "end",
                sortable: true,
                value: "irgFebruary"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.MARCH')}`,
                align: "end",
                sortable: true,
                value: "baseImposableMarch"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.MARCH')}`,
                align: "end",
                sortable: true,
                value: "irgMarch"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.APRIL')}`,
                align: "end",
                sortable: true,
                value: "baseImposableApril"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.APRIL')}`,
                align: "end",
                sortable: true,
                value: "irgApril"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.MAY')}`,
                align: "end",
                sortable: true,
                value: "baseImposableMay"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.MAY')}`,
                align: "end",
                sortable: true,
                value: "irgMay"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.JUNE')}`,
                align: "end",
                sortable: true,
                value: "baseImposableJune"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.JUNE')}`,
                align: "end",
                sortable: true,
                value: "irgJune"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.JULY')}`,
                align: "end",
                sortable: true,
                value: "baseImposableJuly"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.JULY')}`,
                align: "end",
                sortable: true,
                value: "irgJuly"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.AUGUST')}`,
                align: "end",
                sortable: true,
                value: "baseImposableAugust"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.AUGUST')}`,
                align: "end",
                sortable: true,
                value: "irgAugust"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.SEPTEMBER')}`,
                align: "end",
                sortable: true,
                value: "baseImposableSeptember"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.SEPTEMBER')}`,
                align: "end",
                sortable: true,
                value: "irgSeptember"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.OCTOBER')}`,
                align: "end",
                sortable: true,
                value: "baseImposableOctober"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.OCTOBER')}`,
                align: "end",
                sortable: true,
                value: "irgOctober"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.NOVEMBER')}`,
                align: "end",
                sortable: true,
                value: "baseImposableNovember"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.NOVEMBER')}`,
                align: "end",
                sortable: true,
                value: "irgNovember"
            },
            
            {
                text: `${$i18n.t('impression.impos')} ${$i18n.t('common.DECEMBER')}`,
                align: "end",
                sortable: true,
                value: "baseImposableDecember"
            },
            {
                text: `${$i18n.t('impression.irg')} ${$i18n.t('common.DECEMBER')}`,
                align: "end",
                sortable: true,
                value: "irgDecember"
            },
        ];
        
        
        function verifier() {
            loading.value = true;
            axios.get('/printed/getDeclarationIrg301Bis', {
                params: transformFilterValues({
                    ...filter.value,
                    cnasAgencyId: cnasAgencyId.value,
                    year: year.value,
                })
            }).then((response) => {
                irgs.value = response.data.workerIrgs;
                let totalObject = {
                    isTotal: true,
                    fonction: $i18n.t('common.total_general'),
                    baseImposableJanuary: response.data.baseImposableJanuary,
                    irgJanuary: response.data.irgJanuary,
                    baseImposableFebruary: response.data.baseImposableFebruary,
                    irgFebruary: response.data.irgFebruary,
                    baseImposableMarch: response.data.baseImposableMarch,
                    irgMarch: response.data.irgMarch,
                    baseImposableApril: response.data.baseImposableApril,
                    irgApril: response.data.irgApril,
                    baseImposableMay: response.data.baseImposableMay,
                    irgMay: response.data.irgMay,
                    baseImposableJune: response.data.baseImposableJune,
                    irgJune: response.data.irgJune,
                    baseImposableJuly: response.data.baseImposableJuly,
                    irgJuly: response.data.irgJuly,
                    baseImposableAugust: response.data.baseImposableAugust,
                    irgAugust: response.data.irgAugust,
                    baseImposableSeptember: response.data.baseImposableSeptember,
                    irgSeptember: response.data.irgSeptember,
                    baseImposableOctober: response.data.baseImposableOctober,
                    irgOctober: response.data.irgOctober,
                    baseImposableNovember: response.data.baseImposableNovember,
                    irgNovember: response.data.irgNovember,
                    baseImposableDecember: response.data.baseImposableDecember,
                    irgDecember: response.data.irgDecember,
                    
                    totalBaseImposable: response.data.totalBaseImposable,
                    totalIrg: response.data.totalIrg,
                };
                
                irgs.value.unshift(totalObject);
                
            }).finally(() => {
                loading.value = false;
            })
        }
        
        const downloadLoading = ref(false);
        
        function download() {
            downloadLoading.value = true;
            axios.get(`/printed/exportDeclarationIrg301Bis`, {
                responseType: 'blob',
                params: transformFilterValues({
                    ...filter.value,
                    cnasAgencyId: cnasAgencyId.value,
                    year: year.value,
                }),
            }).then(response => {
                // Create a new Blob object using the response data of the file
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `ETAT_IRG_${year.value}.xlsx`);
                document.body.appendChild(fileLink);
                
                fileLink.click();
                
                window.URL.revokeObjectURL(fileURL);
                fileLink.remove();
            }).finally(() => {
                downloadLoading.value = false;
            });
        }
        
        function totalRowColor(item) {
            if (item.isTotal) {
                return 'teal lighten-4';
            } else {
                return rowColor(item);
            }
        }
        
        onMounted(() => verifier());
        
        return {
            loading,
            filter,
            cnasAgencyId,
            year,
            headers,
            irgs,
            downloadLoading,
            download,
            clearFilter,
            rowColor,
            totalRowColor,
            itemClick,
            priceFormat,
            verifier,
        }
    }
}
</script>

<template>
    <w-app
        :title="$t('module.declaration_irg_301_bis')"
        show-filter
        :filter="filter"
        @clearFilter="clearFilter"
    >
        <template v-slot:filter>
            <pay-slip-filter v-model="filter"/>
        </template>
        
        <template v-slot:rightToolbar>
            <impression-models/>
            <w-btn
                color="teal"
                :loading="loading"
                :text="$t('common.verify')"
                icon="mdi-check-all"
                @press="verifier"
            />
            <w-btn
                color="teal"
                :loading="downloadLoading"
                :text="$t('common.download')"
                icon="mdi-monitor-arrow-down"
                @press="download"
            />
        </template>
        <template v-slot:content>
            <v-card>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <str-cnas-agcency-autocomplete
                                v-model="cnasAgencyId"
                                :label="$t('module.cnas_agency')"
                                not-clearable
                                set-default
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <w-text-field
                                v-model="year"
                                not-clearable
                                type="number"
                                :label="$t('common.year')"
                            />
                        </v-col>
                    </v-row>
                    <br/>
                    <w-data-table
                        :headers="headers"
                        :items="irgs"
                        :loading="loading"
                        disable-pagination
                        fixed-header
                        height="600"
                    >
                        <template v-slot:[`item.matricule`]="{ item }">
                            <w-chip :text="item.matricule"/>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                            <w-inline-text bold :text="item.name"/>
                        </template>
                        <template v-slot:[`item.situationFamiliale`]="{ item }">
                            <w-inline-text :text="item.situationFamiliale"/>
                        </template>
                        <template v-slot:[`item.nombreEnfant`]="{ item }">
                            <w-chip outlined :text="item.nombreEnfant"/>
                        </template>
                        <template v-slot:[`item.fonction`]="{ item }">
                            <w-chip
                                :large="item.isTotal"
                                outlined
                                :text="item.fonction"
                            />
                        </template>
                        <template v-slot:[`item.totalBaseImposable`]="{ item }">
                            <w-inline-text bold clazz="red--text" :text="priceFormat(item.totalBaseImposable)"/>
                        </template>
                        <template v-slot:[`item.totalIrg`]="{ item }">
                            <w-inline-text bold clazz="red--text" :text="priceFormat(item.totalIrg)"/>
                        </template>
                        <template v-slot:[`item.baseImposableJanuary`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableJanuary)"/>
                        </template>
                        <template v-slot:[`item.irgJanuary`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgJanuary)"/>
                        </template>
                        <template v-slot:[`item.baseImposableFebruary`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableFebruary)"/>
                        </template>
                        <template v-slot:[`item.irgFebruary`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgFebruary)"/>
                        </template>
                        <template v-slot:[`item.baseImposableMarch`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableMarch)"/>
                        </template>
                        <template v-slot:[`item.irgMarch`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgMarch)"/>
                        </template>
                        <template v-slot:[`item.baseImposableApril`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableApril)"/>
                        </template>
                        <template v-slot:[`item.irgApril`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgApril)"/>
                        </template>
                        <template v-slot:[`item.baseImposableMay`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableMay)"/>
                        </template>
                        <template v-slot:[`item.irgMay`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgMay)"/>
                        </template>
                        <template v-slot:[`item.baseImposableJune`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableJune)"/>
                        </template>
                        <template v-slot:[`item.irgJune`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgJune)"/>
                        </template>
                        <template v-slot:[`item.baseImposableJuly`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableJuly)"/>
                        </template>
                        <template v-slot:[`item.irgJuly`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgJuly)"/>
                        </template>
                        <template v-slot:[`item.baseImposableAugust`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableAugust)"/>
                        </template>
                        <template v-slot:[`item.irgAugust`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgAugust)"/>
                        </template>
                        <template v-slot:[`item.baseImposableSeptember`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableSeptember)"/>
                        </template>
                        <template v-slot:[`item.irgSeptember`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgSeptember)"/>
                        </template>
                        <template v-slot:[`item.baseImposableOctober`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableOctober)"/>
                        </template>
                        <template v-slot:[`item.irgOctober`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgOctober)"/>
                        </template>
                        <template v-slot:[`item.baseImposableNovember`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableNovember)"/>
                        </template>
                        <template v-slot:[`item.irgNovember`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgNovember)"/>
                        </template>
                        <template v-slot:[`item.baseImposableDecember`]="{ item }">
                            <w-inline-text :text="priceFormat(item.baseImposableDecember)"/>
                        </template>
                        <template v-slot:[`item.irgDecember`]="{ item }">
                            <w-inline-text :text="priceFormat(item.irgDecember)"/>
                        </template>
                    </w-data-table>
                </v-container>
            </v-card>
        </template>
    </w-app>
</template>

<style scoped>

</style>